import { DataFieldType } from "src/types/data-field.types";
import { createNodeDef } from "../../nodes.helpers";
import { randEmail } from "@ngneat/falso";

type Options = Exclude<Parameters<typeof randEmail>[0], undefined>;
type NameSeparator = Exclude<Options["nameSeparator"], undefined> | "";

const nameSeparators: Record<NameSeparator, string> = {
  "": "",
  ".": ".",
  "-": "-",
  _: "_",
  "+": "+",
  none: "none",
};

export const randEmailNodeDef = createNodeDef({
  type: "randEmail",
  displayName: "Email",
  defaultName: "email",
  fields: [
    {
      type: DataFieldType.TEXT,
      key: "firstName",
      label: "First name",
    },
    {
      type: DataFieldType.TEXT,
      key: "lastName",
      label: "Last name",
    },
    {
      type: DataFieldType.SELECT,
      key: "nameSeparator",
      label: "Separator",
      options: nameSeparators,
    },
    {
      type: DataFieldType.TEXT,
      key: "provider",
      label: "Provider",
    },
    {
      type: DataFieldType.TEXT,
      key: "suffix",
      label: "Suffix",
    },
  ],
  initialData: (): {
    nameSeparator: NameSeparator;
    firstName: string;
    lastName: string;
    provider: string;
    suffix: string;
  } => ({
    nameSeparator: "",
    firstName: "",
    lastName: "",
    provider: "",
    suffix: "",
  }),
  generate: ({ node }) => {
    return randEmail({
      nameSeparator: node.data.nameSeparator || undefined,
      firstName: node.data.firstName || undefined,
      lastName: node.data.lastName || undefined,
      provider: node.data.provider || undefined,
      suffix: node.data.suffix || undefined,
    });
  },
});
